export const PickupPin = ({ isDark = false, large = false }) => {
    const colorOne = isDark ? "#8EE4CA" : "#2E5D4B";
    const colorTwo = isDark ? "#14201E" : "#E9F8F3";
    const width = large ? 58 : 32;
    const height = large ? 71 : 40;

    return (
        <svg width={width} height={height} viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.4" filter="url(#filter0_f_2851_9238)">
                <path
                    d="M16 36.4404C17.0794 36.4404 18.0419 36.5498 18.7217 36.7197C19.065 36.8055 19.3118 36.9015 19.4619 36.9902C19.4669 36.9932 19.471 36.9972 19.4756 37C19.471 37.0028 19.4669 37.0068 19.4619 37.0098C19.3118 37.0985 19.065 37.1945 18.7217 37.2803C18.0419 37.4502 17.0794 37.5596 16 37.5596C14.9206 37.5596 13.9581 37.4502 13.2783 37.2803C12.935 37.1945 12.6882 37.0985 12.5381 37.0098C12.5328 37.0067 12.5282 37.003 12.5234 37C12.5282 36.997 12.5328 36.9933 12.5381 36.9902C12.6882 36.9015 12.935 36.8055 13.2783 36.7197C13.9581 36.5498 14.9206 36.4404 16 36.4404Z"
                    stroke="black"
                    strokeWidth="0.88075"
                />
            </g>
            <rect x="15.5" y="30.5" width="1" height="6" rx="0.5" fill={colorOne} stroke={colorOne} />
            <circle cx="16" cy="16" r="15.25" fill={colorTwo} stroke={colorOne} strokeWidth="1.5" />
            <rect x="12" y="12" width="8" height="8" rx="4" fill={colorOne} />
            <defs>
                <filter
                    id="filter0_f_2851_9238"
                    x="10.2385"
                    y="34.2385"
                    width="11.523"
                    height="5.523"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="0.88075" result="effect1_foregroundBlur_2851_9238" />
                </filter>
            </defs>
        </svg>
    );
};
